import React, { useState } from 'react';
import { RemoveTypes, RemoveFormProps } from './interfaces';
import { removeTypeOptions, ContentComponent } from './helpers';
import { Grid, Typography } from '@material-ui/core';
import CustomSelectSimple from 'components/CustomSelectSimple';
import { useSelector } from 'react-redux';
import { RootState } from 'store';
import { isLoading } from 'utils/loading';
import Loading from 'components/Loading';

const RemoveForm = ({ handleClose }: RemoveFormProps): JSX.Element => {
  const [removeType, setRemoveType] = useState<RemoveTypes | null>(null);

  const { removeLoading } = useSelector(
    (state: RootState) => state.distributionContracts,
  );

  const isLoadingAtRemove = isLoading([removeLoading]);

  const Content = ContentComponent[removeType];

  const handleChange = (
    event: React.ChangeEvent<{
      value: RemoveTypes;
    }>,
  ) => {
    setRemoveType(event.target.value);
  };

  return (
    <Grid container direction="column" justifyContent="center" spacing={2}>
      {isLoadingAtRemove && <Loading />}
      <Grid item>
        <Typography>Tipo de Remoção</Typography>
        <CustomSelectSimple
          options={removeTypeOptions}
          onChange={handleChange}
        />
      </Grid>
      {removeType && <Content handleClose={handleClose} />}
    </Grid>
  );
};

export default RemoveForm;
